import Api from '@/services/Api'
const path = 'currency'

export default {
    get() {
        return Api().get(path, {})
    }
}